import {Component, OnInit} from '@angular/core';
import {BaseListComponent} from "../base-list/base-list.component";
import {NgIf} from "@angular/common";
import {TemplateComponent} from "../template/template.component";
import {ActivatedRoute, Router} from "@angular/router";
import {CrudService} from "../service/crud.service";
import {BaseEditComponent} from "../base-edit/base-edit.component";
import {EInputType, IEditConfig} from "../../../interface/table.config";
import {ICrudRes} from "../../../interface/http.config";
import {Validators} from "@angular/forms";

@Component({
  selector: 'app-client-edit',
  standalone: true,
  imports: [
    BaseListComponent,
    NgIf,
    TemplateComponent,
    BaseEditComponent
  ],
  templateUrl: './client-edit.component.html',
  styleUrl: './client-edit.component.scss'
})
export class ClientEditComponent implements OnInit {
  data: ICrudRes;
  id: string | null = null;

  constructor(protected router: Router,
              protected route: ActivatedRoute,
              protected crudService: CrudService) {

  }

  editLink = '/dashboard/client-edit/';
  menuLink = '/dashboard/client';
  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id') || null;

    this.crudService.provider = 'client';

    if (this.editConfig.groups.length && this.id) {

      this.editConfig.groups[0].configs = [
        {
          field: 'id',
          type: EInputType.DISABLED,
          name: 'Id',
          validators: [],
        },
        ...this.editConfig.groups[0].configs
      ];

      this.getItem();
    } else {
      this.data = {
        verified: false,
        blocked: false,
        twoFactor: true,
        subscribeMails: false,
      } as any;
    }
  }

  editConfig: IEditConfig = {
    groups: [
      {
        name: 'General (New Client)',
        configs: [
          {field: 'email', name: 'Email', type: EInputType.EMAIL, validators: [Validators.required]},
          {field: 'createdAt', name: 'Created', type: EInputType.DATETIME, validators: [Validators.required]},
          {field: 'verified', name: 'verified', type: EInputType.BOOLEAN, validators: [Validators.required]},
          {field: 'blocked', name: 'blocked', type: EInputType.BOOLEAN, validators: [Validators.required]},
          {field: 'comment', name: 'Comment', type: EInputType.TEXTAREA, validators: []},
          {field: 'twoFactor', name: 'Tow Factor Auth', type: EInputType.BOOLEAN, validators: []},
          {field: 'subscribeMails', name: 'Subscribe Mails', type: EInputType.BOOLEAN, validators: []},
        ]
      }
    ]
  };

  getItem() {
    this.crudService.item({id: this.id}).then(item => {
      this.data = item;

      this.editConfig.groups[0].name = 'General (Client ' + item.email + ')';
    }).catch(console.error);
  }

  onAction(actionName: string, item: any) {
    if (actionName === 'submit') {
      this.crudService.save(item).then((data) => {
        if (!item.id) {
          this.router.navigate([this.editLink + '/' + data.document.id]).catch(console.error);
        } else {
          this.getItem();
        }
      });
    }

    if (actionName === 'back') {
      this.router.navigate([this.menuLink]).catch(console.error);
    }
  }
}
